"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductTypes = void 0;
/**
 * @deprecated use Offer Subtype
 */
var ProductTypes;
(function (ProductTypes) {
    ProductTypes["UNKNOWN"] = "UNKNOWN";
    ProductTypes["FOOD"] = "FOOD";
    ProductTypes["MEALS"] = "MEALS";
    ProductTypes["CANNED_FOOD"] = "CANNED_FOOD";
    ProductTypes["DRY_FOOD"] = "DRY_FOOD";
    ProductTypes["RAW_FOOD"] = "RAW_FOOD";
    ProductTypes["HUMAN_GRADE"] = "HUMAN_GRADE";
    ProductTypes["FROZEN_FOOD"] = "FROZEN_FOOD";
    ProductTypes["FREEZE_DRIED"] = "FREEZE_DRIED";
    ProductTypes["TREATS"] = "TREATS";
    ProductTypes["BISCUITS_BAKERY"] = "BISCUITS_BAKERY";
    ProductTypes["BONES_RAWHIDE"] = "BONES_RAWHIDE";
    ProductTypes["CHEWY_TREATS"] = "CHEWY_TREATS";
    ProductTypes["JERKY"] = "JERKY";
    ProductTypes["TRAINING_TREATS"] = "TRAINING_TREATS";
    ProductTypes["FREEZE_DRIED_TREATS"] = "FREEZE_DRIED_TREATS";
    ProductTypes["DEHYDRATED_TREATS"] = "DEHYDRATED_TREATS";
    ProductTypes["PILL_COVERS"] = "PILL_COVERS";
    ProductTypes["VETERINARY_DIET"] = "VETERINARY_DIET";
    ProductTypes["VETERINARY_MEALS"] = "VETERINARY_MEALS";
    ProductTypes["VETERINARY_TREATS"] = "VETERINARY_TREATS";
    ProductTypes["MISC"] = "MISC";
    ProductTypes["UTENSILS"] = "UTENSILS";
    ProductTypes["TOPPINGS"] = "TOPPINGS";
    ProductTypes["TOYS"] = "TOYS";
    ProductTypes["BALLS"] = "BALLS";
    ProductTypes["PLUSH_TOYS"] = "PLUSH_TOYS";
    ProductTypes["ROPE_TOYS"] = "ROPE_TOYS";
    ProductTypes["FETCH_TOYS"] = "FETCH_TOYS";
    ProductTypes["TUG_TOYS"] = "TUG_TOYS";
    ProductTypes["INTERACTIVE_TOYS"] = "INTERACTIVE_TOYS";
    ProductTypes["CHEW_TOYS"] = "CHEW_TOYS";
    ProductTypes["TOY_BINS"] = "TOY_BINS";
    ProductTypes["SCRATCHERS"] = "SCRATCHERS";
    ProductTypes["WELLNESS"] = "WELLNESS";
    ProductTypes["FLEAS_TICKS"] = "FLEAS_TICKS";
    ProductTypes["FLEA_COLLARS"] = "FLEA_COLLARS";
    ProductTypes["FLEA_ORAL_TREATMENT"] = "FLEA_ORAL_TREATMENT";
    ProductTypes["FLEA_SPOT_TREATMENT"] = "FLEA_SPOT_TREATMENT";
    ProductTypes["FLEA_SHAMPOO"] = "FLEA_SHAMPOO";
    ProductTypes["FLEA_SPRAY_WIPES"] = "FLEA_SPRAY_WIPES";
    ProductTypes["FLEA_HOME_YARD_TREATMENT"] = "FLEA_HOME_YARD_TREATMENT";
    ProductTypes["FLEA_YARD_TREATMENT"] = "FLEA_YARD_TREATMENT";
    ProductTypes["FLEA_HOME_TREATMENT"] = "FLEA_HOME_TREATMENT";
    ProductTypes["FLEA_COMB_BRUSHES"] = "FLEA_COMB_BRUSHES";
    ProductTypes["PHARMACY"] = "PHARMACY";
    ProductTypes["VITAMINS_SUPPLEMENTS"] = "VITAMINS_SUPPLEMENTS";
    ProductTypes["EAR_CARE"] = "EAR_CARE";
    ProductTypes["EAR_CARE_LIQUIDS"] = "EAR_CARE_LIQUIDS";
    ProductTypes["EAR_CARE_CLEANERS"] = "EAR_CARE_CLEANERS";
    ProductTypes["EAR_CARE_WIPES"] = "EAR_CARE_WIPES";
    ProductTypes["EAR_CARE_GELS_POWDERS"] = "EAR_CARE_GELS_POWDERS";
    ProductTypes["EYE_CARE"] = "EYE_CARE";
    ProductTypes["EYE_CARE_LIQUIDS"] = "EYE_CARE_LIQUIDS";
    ProductTypes["EYE_CARE_CLEANERS"] = "EYE_CARE_CLEANERS";
    ProductTypes["EYE_CARE_WIPES"] = "EYE_CARE_WIPES";
    ProductTypes["EYE_CARE_GELS_POWDERS"] = "EYE_CARE_GELS_POWDERS";
    ProductTypes["DENTAL"] = "DENTAL";
    ProductTypes["DENTAL_SUPPLEMENTS"] = "DENTAL_SUPPLEMENTS";
    ProductTypes["DENTAL_TREATS"] = "DENTAL_TREATS";
    ProductTypes["DENTAL_FRESHENERS_CLEANING"] = "DENTAL_FRESHENERS_CLEANING";
    ProductTypes["TOOTH_BRUSHES"] = "TOOTH_BRUSHES";
    ProductTypes["TOOTHPASTE_GELS"] = "TOOTHPASTE_GELS";
    ProductTypes["DENTAL_SPRAYS_FOAMS_WIPES"] = "DENTAL_SPRAYS_FOAMS_WIPES";
    ProductTypes["DIGESTIVE_URINARY"] = "DIGESTIVE_URINARY";
    ProductTypes["DIGESTIVE_HEALTH"] = "DIGESTIVE_HEALTH";
    ProductTypes["CLEANING_POTTY"] = "CLEANING_POTTY";
    ProductTypes["POTTY_PADS_DIAPERS"] = "POTTY_PADS_DIAPERS";
    ProductTypes["POTTY_PADS"] = "POTTY_PADS";
    ProductTypes["PAD_HOLDERS"] = "PAD_HOLDERS";
    ProductTypes["DIAPERS_WRAPS"] = "DIAPERS_WRAPS";
    ProductTypes["LITTER_TURF"] = "LITTER_TURF";
    ProductTypes["POOP_BAGS_SCOOPERS"] = "POOP_BAGS_SCOOPERS";
    ProductTypes["POOP_BAG_DISPENSER"] = "POOP_BAG_DISPENSER";
    ProductTypes["POOP_BAG"] = "POOP_BAG";
    ProductTypes["POOP_SCOOPERS"] = "POOP_SCOOPERS";
    ProductTypes["VACUUMS_STEAM_CLEANERS"] = "VACUUMS_STEAM_CLEANERS";
    ProductTypes["STAIN_REMOVERS"] = "STAIN_REMOVERS";
    ProductTypes["DEODORIZERS"] = "DEODORIZERS";
    ProductTypes["CANDLES"] = "CANDLES";
    ProductTypes["AIR_FRESHENERS"] = "AIR_FRESHENERS";
    ProductTypes["DEODOR_TREATMENT"] = "DEODOR_TREATMENT";
    ProductTypes["LINTERS"] = "LINTERS";
    ProductTypes["CONTAINMENT"] = "CONTAINMENT";
    ProductTypes["CRATES"] = "CRATES";
    ProductTypes["CAR_CRATES"] = "CAR_CRATES";
    ProductTypes["CRATE_COVERS_ACCESSORIES"] = "CRATE_COVERS_ACCESSORIES";
    ProductTypes["FURNITURE_STYLE_CRATE"] = "FURNITURE_STYLE_CRATE";
    ProductTypes["WIRE_CRATES"] = "WIRE_CRATES";
    ProductTypes["SOFT_SIDED_CRATES"] = "SOFT_SIDED_CRATES";
    ProductTypes["CRATE_MATS_PADS"] = "CRATE_MATS_PADS";
    ProductTypes["KENNELS"] = "KENNELS";
    ProductTypes["PLAY_PENS"] = "PLAY_PENS";
    ProductTypes["PLAY_PEN_ACCESSORIES"] = "PLAY_PEN_ACCESSORIES";
    ProductTypes["GATES"] = "GATES";
    ProductTypes["PRESSURE_MOUNTED"] = "PRESSURE_MOUNTED";
    ProductTypes["HARDWARE_MOUNTED"] = "HARDWARE_MOUNTED";
    ProductTypes["FREE_STANDING"] = "FREE_STANDING";
    ProductTypes["STEPS_RAMPS"] = "STEPS_RAMPS";
    ProductTypes["DOORS"] = "DOORS";
    ProductTypes["DOOR_ACCESSORIES"] = "DOOR_ACCESSORIES";
    ProductTypes["FENCE_SYSTEMS"] = "FENCE_SYSTEMS";
    ProductTypes["DOG_HOUSES"] = "DOG_HOUSES";
    ProductTypes["CARRIERS"] = "CARRIERS";
    ProductTypes["STROLLERS_BICYCLE_TRAILERS"] = "STROLLERS_BICYCLE_TRAILERS";
    ProductTypes["CAR_ACCESSORIES"] = "CAR_ACCESSORIES";
    ProductTypes["SEAT_BELTS"] = "SEAT_BELTS";
    ProductTypes["BARRIERS"] = "BARRIERS";
    ProductTypes["SEAT_COVERS"] = "SEAT_COVERS";
    ProductTypes["BEDS_FURNITURE"] = "BEDS_FURNITURE";
    ProductTypes["ORTHOPEDIC_BEDS"] = "ORTHOPEDIC_BEDS";
    ProductTypes["PILLOW_BEDS"] = "PILLOW_BEDS";
    ProductTypes["ELEVATED_COOLING_BEDS"] = "ELEVATED_COOLING_BEDS";
    ProductTypes["HEATED_BEDS"] = "HEATED_BEDS";
    ProductTypes["COVERED_BEDS"] = "COVERED_BEDS";
    ProductTypes["BOLSTER_BEDS"] = "BOLSTER_BEDS";
    ProductTypes["SOLD_BEDS"] = "SOLD_BEDS";
    ProductTypes["LARGE_BEDS"] = "LARGE_BEDS";
    ProductTypes["SOFA_BEDS"] = "SOFA_BEDS";
    ProductTypes["BLANKETS_COVERS"] = "BLANKETS_COVERS";
    ProductTypes["BOWLS_FEEDER"] = "BOWLS_FEEDER";
    ProductTypes["TRAVEL_BOWLS_BAGS"] = "TRAVEL_BOWLS_BAGS";
    ProductTypes["BOWLS_DINERS"] = "BOWLS_DINERS";
    ProductTypes["BOWLS_DISHES"] = "BOWLS_DISHES";
    ProductTypes["ELEVATED_BOWLS"] = "ELEVATED_BOWLS";
    ProductTypes["SLOW_FEEDERS"] = "SLOW_FEEDERS";
    ProductTypes["FEEDERS_WATERERS"] = "FEEDERS_WATERERS";
    ProductTypes["FEEDERS"] = "FEEDERS";
    ProductTypes["WATERERS"] = "WATERERS";
    ProductTypes["FOUNTAIN_FILTERS"] = "FOUNTAIN_FILTERS";
    ProductTypes["WATER_FOUNTAINS"] = "WATER_FOUNTAINS";
    ProductTypes["FILTERS_PUMPS"] = "FILTERS_PUMPS";
    ProductTypes["PLACEMATS"] = "PLACEMATS";
    ProductTypes["STORAGE_ACCESSORIES"] = "STORAGE_ACCESSORIES";
    ProductTypes["FOOD_STORAGE"] = "FOOD_STORAGE";
    ProductTypes["CAN_COVERS"] = "CAN_COVERS";
    ProductTypes["TREAT_JARS"] = "TREAT_JARS";
    ProductTypes["FOOD_SCOOPS"] = "FOOD_SCOOPS";
    ProductTypes["CLOTHING"] = "CLOTHING";
    ProductTypes["SHIRTS"] = "SHIRTS";
    ProductTypes["SWEATTER"] = "SHIRTS";
    ProductTypes["OUTDOOR_GEAR"] = "OUTDOOR_GEAR";
    ProductTypes["WINTER_GEAR"] = "WINTER_GEAR";
    ProductTypes["SAFETY_GEAR"] = "SAFETY_GEAR";
    ProductTypes["LIFE_JACKETS"] = "LIFE_JACKETS";
    ProductTypes["BACKPACKS"] = "BACKPACKS";
    ProductTypes["COOLING_VESTS_GEAR"] = "COOLING_VESTS_GEAR";
    ProductTypes["INSECT_SUN_PROTECTION"] = "INSECT_SUN_PROTECTION";
    ProductTypes["RAIN_GEAR"] = "RAIN_GEAR";
    ProductTypes["DRESSES"] = "DRESSES";
    ProductTypes["JERSEY_TEAM_ACCESSORIES"] = "JERSEY_TEAM_ACCESSORIES";
    ProductTypes["JERSEY_TEAM_COLLARS_LEASHES"] = "JERSEY_TEAM_COLLARS_LEASHES";
    ProductTypes["JERSEY_TEAM_JERSEYS"] = "JERSEY_TEAM_JERSEYS";
    ProductTypes["PAJAMAS"] = "PAJAMAS";
    ProductTypes["BOOTS"] = "BOOTS";
    ProductTypes["SOCKS"] = "SOCKS";
    ProductTypes["BANDANAS_SCARVES"] = "BANDANAS_SCARVES";
    ProductTypes["BOW_TIES"] = "BOW_TIES";
    ProductTypes["HATS"] = "HATS";
    ProductTypes["COSTUMES"] = "COSTUMES";
    ProductTypes["WALKING"] = "WALKING";
    ProductTypes["LEASHES"] = "LEASHES";
    ProductTypes["LEASH_BASIC"] = "LEASH_BASIC";
    ProductTypes["LEASH_RETRACTABLE"] = "LEASH_RETRACTABLE";
    ProductTypes["LEASH_HANDS_FREE"] = "LEASH_HANDS_FREE";
    ProductTypes["LEASH_DOUBLE_COUPLERS"] = "LEASH_DOUBLE_COUPLERS";
    ProductTypes["HARNESSES"] = "HARNESSES";
    ProductTypes["HARNESS_BASIC"] = "HARNESS_BASIC";
    ProductTypes["HARNESS_SERVICE_DOG"] = "HARNESS_SERVICE_DOG";
    ProductTypes["HARNESS_NO_PULL"] = "HARNESS_NO_PULL";
    ProductTypes["HARNESS_HANDICAPPED_SUPPORT"] = "HARNESS_HANDICAPPED_SUPPORT";
    ProductTypes["HARNESS_FRONT_CLIP"] = "HARNESS_FRONT_CLIP";
    ProductTypes["COLLARS"] = "COLLARS";
    ProductTypes["COLLARS_PERSONALIZED"] = "COLLARS_PERSONALIZED";
    ProductTypes["COLLARS_BASIC"] = "COLLARS_BASIC";
    ProductTypes["MUZZLES_HEAD_COLLARS"] = "MUZZLES_HEAD_COLLARS";
    ProductTypes["ID_TAGS"] = "ID_TAGS";
    ProductTypes["SERVICE_DOG_PATCHES"] = "SERVICE_DOG_PATCHES";
    ProductTypes["PERSONALIZED_ID_TAGS"] = "PERSONALIZED_ID_TAGS";
    ProductTypes["COLLAR_LIGHTS"] = "COLLAR_LIGHTS";
    ProductTypes["COLLAR_CHARMS"] = "COLLAR_CHARMS";
    ProductTypes["ID_TAG_ACCESSORIES"] = "ID_TAG_ACCESSORIES";
    ProductTypes["LEASH_COLLAR_ACCESSORIES"] = "LEASH_COLLAR_ACCESSORIES";
    ProductTypes["TIE_OUTS"] = "TIE_OUTS";
    ProductTypes["TIE_OUT_STAKES"] = "TIE_OUT_STAKES";
    ProductTypes["TIE_OUT_CABLES"] = "TIE_OUT_CABLES";
    ProductTypes["GROOMING"] = "GROOMING";
    ProductTypes["GROOMING_TOOLS"] = "GROOMING_TOOLS";
    ProductTypes["CLIPPER_BLADES"] = "CLIPPER_BLADES";
    ProductTypes["CLIPPER_BLADES_PARTS"] = "CLIPPER_BLADES_PARTS";
    ProductTypes["HAIR_CLIPPER_SHEARS"] = "HAIR_CLIPPER_SHEARS";
    ProductTypes["GROOMING_TABLES"] = "GROOMING_TABLES";
    ProductTypes["GROOMING_APPAREL_EXTRAS"] = "GROOMING_APPAREL_EXTRAS";
    ProductTypes["SHAMPOOS_CONDITIONERS"] = "SHAMPOOS_CONDITIONERS";
    ProductTypes["SHAMPOOS"] = "SHAMPOOS";
    ProductTypes["CONDITIONERS"] = "CONDITIONERS";
    ProductTypes["BRUSHES_COMBS"] = "BRUSHES_COMBS";
    ProductTypes["SKIN_CARE_SKIN_CARE"] = "SKIN_CARE_SKIN_CARE";
    ProductTypes["SKIN_CARE_SUN_SCREEN"] = "SKIN_CARE_SUN_SCREEN";
    ProductTypes["SKIN_CARE_MOISTURIZER"] = "SKIN_CARE_MOISTURIZER";
    ProductTypes["SKIN_CARE_HOT_SPOT_ITCH_RELIEF"] = "SKIN_CARE_HOT_SPOT_ITCH_RELIEF";
    ProductTypes["SKIN_CARE_BALM"] = "SKIN_CARE_BALM";
    ProductTypes["SKIN_CARE_WIPES"] = "SKIN_CARE_WIPES";
    ProductTypes["PAW_NAIL_CARE"] = "PAW_NAIL_CARE";
    ProductTypes["PAW_CARE"] = "PAW_CARE";
    ProductTypes["NAIL_CLIPPERS"] = "NAIL_CLIPPERS";
    ProductTypes["NAIL_GRINDERS_ACCESSORIES"] = "NAIL_GRINDERS_ACCESSORIES";
    ProductTypes["NAIL_POLISH_CAPS"] = "NAIL_POLISH_CAPS";
    ProductTypes["WATERLESS_GROOMING"] = "WATERLESS_GROOMING";
    ProductTypes["WATERLESS_BATH"] = "WATERLESS_BATH";
    ProductTypes["DEODORIZING_SPRAYS_COLOGNES"] = "DEODORIZING_SPRAYS_COLOGNES";
    ProductTypes["GROOMING_SPRAYS_DETANGLERS"] = "GROOMING_SPRAYS_DETANGLERS";
    ProductTypes["BATH_SHOWER_SUPPLIES"] = "BATH_SHOWER_SUPPLIES";
    ProductTypes["BATH_TOWELS"] = "BATH_TOWELS";
    ProductTypes["DRYERS"] = "DRYERS";
    ProductTypes["BATHTUB_SHOWER_HOSE_ACCESSORIES"] = "BATHTUB_SHOWER_HOSE_ACCESSORIES";
    ProductTypes["BATH_MATS"] = "BATH_MATS";
    ProductTypes["TRAINING"] = "TRAINING";
    ProductTypes["CALMING_AIDS"] = "CALMING_AIDS";
    ProductTypes["TRAVEL_AIDS"] = "TRAVEL_AIDS";
    ProductTypes["TRAINING_LEASHES_COLLARS"] = "TRAINING_LEASHES_COLLARS";
    ProductTypes["BARK_CONTROLLING_REMOTE_TRAINING"] = "BARK_CONTROLLING_REMOTE_TRAINING";
    ProductTypes["BARK_CONTROLLING_REMOTE_TRAINING_COLLARS"] = "BARK_CONTROLLING_REMOTE_TRAINING_COLLARS";
    ProductTypes["BARK_CONTROLLING_REMOTE_TRAINING_SYSTEMS"] = "BARK_CONTROLLING_REMOTE_TRAINING_SYSTEMS";
    ProductTypes["BARK_CONTROLLING_REMOTE_TRAINING_CHARGER_ACCESSORIES"] = "BARK_CONTROLLING_REMOTE_TRAINING_CHARGER_ACCESSORIES";
    ProductTypes["BARK_CONTROLLING_REMOTE_TRAINING_BATTERIES"] = "BARK_CONTROLLING_REMOTE_TRAINING_BATTERIES";
    ProductTypes["REPELLENTS"] = "REPELLENTS";
    ProductTypes["POTTY_TRAINING_AIDS"] = "POTTY_TRAINING_AIDS";
    ProductTypes["AGILITY_TRAINING"] = "AGILITY_TRAINING";
    ProductTypes["SPORT_TRAINING"] = "SPORT_TRAINING";
    ProductTypes["SPORT_TRAINING_LEASHES"] = "SPORT_TRAINING_LEASHES";
    ProductTypes["WHISTLE_EQUIPMENT"] = "WHISTLE_EQUIPMENT";
    ProductTypes["DUMMIES"] = "DUMMIES";
    ProductTypes["CLICKER_EQUIPMENT"] = "CLICKER_EQUIPMENT";
    ProductTypes["DUMMY_LAUNCHER_SYSTEM"] = "DUMMY_LAUNCHER_SYSTEM";
})(ProductTypes = exports.ProductTypes || (exports.ProductTypes = {}));
